import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import CustomLoader from './loader';
import { addMobiguestlinkLogs } from '../services/logs';

const RedirectPage = () => {

    const { id } = useParams();


    const [url, setUrl] = useState(null);
    const navigate = useNavigate();


    const fetchShortUrl = async () => {
        const shortJson = await fetch(`https://shorturl-403625671940.us-central1.run.app/mobilinks/${id}`)
        const output = await shortJson.json()
        if (!output?.data?.original_url) {
            navigate('/404');
        } else {
            window.location.replace(output?.data?.original_url);
            setUrl(output?.data?.original_url)
        }
    }

    useEffect(() => {
        const fullUrl = window.location.href;
        const urlPayload = {
            url: fullUrl,
            redirect: id || "",
            type: "redirect"
        }
        addMobiguestlinkLogs(urlPayload)
        fetchShortUrl();
    }, [id, navigate]);

    if (!url) {
        return <CustomLoader />;
    }

    return (
        <div>

        </div>
    );
};

export default RedirectPage;
